'use client'

import {
	classNameFunc
} from "@dg/common/lib/common"

interface SkeletonProps {
	className?: string;
}

const Skeleton = ({
	className = ``
}: SkeletonProps) => (
	<div
		className={classNameFunc(`animate-pulse bg-dg-400 dark:bg-dgdark-400 ${className}`)}
	/>
)

export default Skeleton
